import { requestBuilder } from '../../http/RequestBuilder';
import type { RegisterDeviceForPushNotificationsDto } from '../types/Notifications';

/**
 * Registers a device with the backend app to be eligible to receive push notifications.
 */
const useRegisterDeviceForPushNotifications = requestBuilder.mutation<
    unknown,
    RegisterDeviceForPushNotificationsDto
>({
    endpoint: '/api/notifications/push/register',
    method: 'POST',
});

export default useRegisterDeviceForPushNotifications;
